/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import areArraysEqual from"./areArraysEqual";import isArray from"./isArray";import isPlainObject from"./isPlainObject";const areObjectsEqual=function(r,e,i){if(!isPlainObject(r)||!isPlainObject(e))return!1;let a={},t=!1;for(var s in 1===i&&(t=!0),r){let l=r[s],n=e[s];if(isPlainObject(l)&&isPlainObject(n)){if(!t&&!areObjectsEqual(l,n,i-1))return!1}else if(isArray(l)&&isArray(n)){if(!t&&!areArraysEqual(l,n,i-1))return!1}else if(l!==n)return!1;a[s]=!0}for(s in e)if(!a[s])return!1;return!0};export default areObjectsEqual;